import { InvoicesCharges } from "../models/invoice.charges";
import BaseService from "./_base.service";

const endpoint = "shipment/invoice";
import API from "../api";

export const ShipmentInvoiceService = {
  ...BaseService<InvoicesCharges>({ endpoint }),
  async uploadInvoices(data: any ) { // mudar o tipo
    return await API.post(`${endpoint}/upload`, data);
  },
};
